import { Component, ElementRef, OnInit, ViewChild, Renderer2, Input, Output, EventEmitter } from '@angular/core';

export interface CropResult {
  coordinates: {
    // è£åªæ¡åè§åæ 
    leftTopX: number;
    leftTopY: number;
    rightTopX: number;
    rightTopY: number;
    rightBottomX: number;
    rightBottomY: number;
    leftBottomX: number;
    leftBottomY: number;
  };
  scale: number;
}

@Component({
  selector: 'ui-cropper',
  templateUrl: './cropper.component.html'
})
export class CropperComponent implements OnInit {
  @ViewChild('imgRef', {static: true}) imgRef: ElementRef;
  @ViewChild('cropperRef', {static: true}) cropperRef: ElementRef;
  // è£åªçå®½åº¦
  @Input() cropWidth = 200;
  // è£åªçé«åº¦
  @Input()
  cropHeight = 200;
  @Input()
  imageURL = '';
  @Output()
  public uiChange = new EventEmitter<CropResult>();
  // å¾çç¸å¯¹å®¹å¨å³ä¸è§çåç§»é
  imageOffsetX = 0;
  imageOffsetY = 0;
  // ç¼©æ¾åæ°
  scale = 1;
  // å¾çç¼©æ¾æ¯ä¾
  private proportion = 1;
  // å®¹å¨å®½åº¦
  private containerWidth = 0;
  // å®¹å¨é«åº¦
  private containerHeight = 0;
  // å¾çåå§å®½åº¦
  private imageOriginWidth = 0;
  // å¾çåå§é«åº¦
  private imageOriginHeight = 0;
  // è®¡ç®åçå¾çå®½åº¦
  private imageWidth = 0;
  // è®¡ç®åçå¾çé«åº¦
  private imageHeight = 0;
  // è£åªæ¡åè§åæ 
  private leftTopX = 0;
  private leftTopY = 0;
  private rightTopX = 0;
  private rightTopY = 0;
  private rightBottomX = 0;
  private rightBottomY = 0;
  private leftBottomX = 0;
  private leftBottomY = 0;
  // æ»è½®ç¼©æ¾çè§£ç»å½æ°
  private unbindWheelFn: () => void;
  private imgElement: HTMLImageElement;

  constructor(private renderer: Renderer2) {
  }

  ngOnInit() {
    this.imgElement = this.imgRef.nativeElement;
    this.imgElement.onload = () => {
      // å¾çå è½½æååå¸å±
      setTimeout(() => {
        this.init();
      }, 1000);
    };
  }

  // åå§å
  init() {
    const cropperElement = this.cropperRef.nativeElement;
    const imgElement = this.imgElement;
    // è·åå®¹å¨çé«åå®½
    this.containerWidth = cropperElement.offsetWidth;
    this.containerHeight = cropperElement.offsetHeight;
    // è·åå¾çççå®é«åº¦
    this.imageOriginWidth = imgElement.width;
    this.imageOriginHeight = imgElement.height;
    // å¦æå¾ççå®å®½åº¦å¤§äºå®¹å¨
    if (this.imageOriginWidth > this.containerWidth) {
      this.proportion = this.containerWidth / this.imageOriginWidth;
      this.imageWidth = this.containerWidth;
      this.imageHeight = this.imageOriginHeight * this.proportion;
      this.imageOffsetX = 0;
      this.imageOffsetY = (this.containerHeight - this.imageHeight) / 2;
    }
    // å¦æå®½åº¦å¤çä¹åå¾çé«åº¦å¤§äºå®¹å¨é«åº¦, å¯¹é«åº¦è¿è¡å¤ç
    if (this.imageHeight > this.containerHeight) {
      this.proportion = this.imageHeight / this.containerHeight;
      this.imageHeight = this.containerHeight;
      this.imageWidth = this.imageWidth * this.proportion;
      this.imageOffsetX = (this.containerWidth - this.imageWidth) / 2;
      this.imageOffsetY = 0;
    }
    imgElement.width = this.imageWidth;
    imgElement.height = this.imageHeight;
  }

  // è®¡ç®åè§åæ 
  computeCoordinates() {
    const cropWidth = this.cropWidth;
    const cropHeight = this.cropHeight;
    const boxLeft = (this.containerWidth - cropWidth) / 2;
    const boxTop = (this.containerHeight - cropHeight) / 2;
    const imageLeft = this.imgElement.offsetLeft;
    const imageTop = this.imgElement.offsetTop;
    this.leftTopX = boxLeft - imageLeft;
    this.leftTopY = boxTop - imageTop;
    this.rightTopX = this.leftTopX + cropWidth;
    this.rightTopY = this.leftTopY;
    this.rightBottomX = this.leftTopX + cropWidth;
    this.rightBottomY = this.rightTopY + cropHeight;
    this.leftBottomX = this.leftTopX;
    this.leftBottomY = this.leftTopY + cropHeight;
    this.uiChange.emit({
      coordinates: {
        leftTopX: this.leftTopX,
        leftTopY: this.leftTopY,
        rightTopX: this.rightTopX,
        rightTopY: this.rightTopY,
        rightBottomX: this.rightBottomX,
        rightBottomY: this.rightBottomY,
        leftBottomX: this.leftBottomX,
        leftBottomY: this.leftBottomY,
      },
      scale: this.scale
    });
  }

  // ç§»å¨å¾ç
  moveImage(ev: MouseEvent) {
    let oldX = ev.clientX;
    let oldY = ev.clientY;
    const move = (e: MouseEvent) => {
      const movementX = e.clientX - oldX;
      const movementY = e.clientY - oldY;
      e.preventDefault();
      if (this.imageOffsetX < -this.imageWidth + 20 && e.movementX < 0 ||
        this.imageOffsetX > this.containerWidth - 20 && e.movementX > 0 ||
        this.imageOffsetY < -this.imageHeight + 20 && e.movementY < 0 ||
        this.imageOffsetY > this.containerHeight - 20 && e.movementY > 0) return;
      this.imageOffsetX += movementX;
      this.imageOffsetY += movementY;
      oldX = e.clientX;
      oldY = e.clientY;
      this.computeCoordinates();
    };
    const moveEnd = () => {
      unbindMouseMoveFn();
      unbindMouseUpFn();
    };
    const unbindMouseMoveFn = this.renderer.listen('document', 'mousemove', move);
    const unbindMouseUpFn = this.renderer.listen('document', 'mouseup', moveEnd);
    ev.preventDefault();
  }

  // ç¼©æ¾å¾ç
  scaleImage() {
    this.unbindWheelFn = this.renderer.listen('document', 'wheel', (e: WheelEvent) => {
      e.preventDefault();
      const change = e.deltaY || e.deltaX;
      const scale = change < 0 ? 1.05 : 0.95;
      this.scale = this.scale * scale;
      this.imageHeight = this.imageHeight * scale;
      this.imageWidth = this.imageWidth * scale;
      this.imgElement.width = this.imageWidth;
      this.imgElement.height = this.imageHeight;
      if (change < 0) {
        this.imageOffsetX -= e.offsetX * 0.05;
        this.imageOffsetY -= e.offsetY * 0.05;
      } else {
        this.imageOffsetX += e.offsetX * 0.05;
        this.imageOffsetY += e.offsetY * 0.05;
      }
      this.computeCoordinates();
    });
  }

  // åæ­¢ç¼©æ¾
  cancelScale() {
    this.unbindWheelFn();
  }
}
